import {
  GET_LIST_DATASET_DETAIL,
  GET_LIST_DATASET_DETAIL_SUCCESS,
  DATASET_DETAIL_CHANGE_LIMIT,
  DATASET_DETAIL_CHANGE_PAGE,
  DATASET_DETAIL_TOGGLE_ONE,
  DATASET_DETAIL_TOGGLE_ALL,
  DATASET_DETAIL_DESELECT_ALL,
  FETCH_MODULE_CODE_REQUEST,
  FETCH_MODULE_CODE_SUCCESS,
  DATASET_DETAIL_CHANGE_FILTER_CONDITION,
  DATASET_DETAIL_CHANGE_ADVANCED_FILTER_CONDITION,
  DATASET_DETAIL_OPEN_SMART_TAG_DRAWER,
  DATASET_DETAIL_CLOSE_SMART_TAG_DRAWER,
  DATASET_DETAIL_SELECT_SOURCE_ID,
  DATASET_UPDATE_ITEMS,
  DATASET_DETAIL_OPEN_ADVANCED_SEARCH_DRAWER,
  DATASET_DETAIL_CLOSE_ADVANCED_SEARCH_DRAWER,
  DATASET_DETAIL_CHANGE_ADVANCED_FILTER,
  DATASET_DETAIL_GET_DATA_BY_ADVANCED,
  DATASET_DETAIL_SET_CURRENT_DATASET_ID,
  DATASET_DETAIL_GET_DATA_BY_ADVANCED_SUCCESS,
  DATASET_DETAIL_CLEAR_ADVANCED_FILTER_CONDITION,
  DATASET_DETAIL_UPDATE_STATUS_IMAGE,
  DATASET_DETAIL_BULK_UPDATE_STATUS_REQUEST,
  DATASET_DETAIL_BULK_UPDATE_STATUS_SUCCESS,
  DATASET_DETAIL_BULK_UPDATE_STATUS_FAILURE,
  DATASET_DETAIL_UPDATE_ITEM_BY_STATUS_SUCCESS,
  DATASET_DETAIL_CHANGE_VIEW_TYPE,
  DATASET_DETAIL_TOGGLE_IMPORT_DATA,
  DATASET_DETAIL_TOGGLE_EXPORT_DATA,
  DATASET_DETAIL_TOGGLE_ASSIGN_MEMBER,
  DATASET_DETAIL_ASSIGN_MEMBER_SUCCESS,
  DATASET_DETAIL_UNCHECK_IDS,
  DATASET_DETAIL_TOGGLE_UNASSIGN_MODAL,
  DATASET_DETAIL_UNASSIGN_MEMBER_SUCCESS,
  DATASET_DETAIL_TOGGLE_DELETE_MODAL,
  DATASET_DETAIL_DELETE_IMAGES,
  DATASET_DETAIL_CLEAR_DATASET_IDS,
  CLEAR_ADVANCED_SEARCH_PAGE_CONDITION,
  DATASET_DETAIL_CHANGE_COUNTS_PER_ROW,
  DATASET_DETAIL_GET_ALL_DATASETS_OF_PROJECT,
  DATASET_DETAIL_GET_ALL_DATASETS_OF_PROJECT_SUCCESS,
  DATASET_DETAIL_GET_MATTRIX_PERMISSION,
  DATASET_DETAIL_GET_MATTRIX_PERMISSION_SUCCESS,
  DATASET_DETAIL_TOGGLE_AUTO_LABEL_DIALOG,
  DATASET_DETAIL_GET_TARGET_LABELS,
  DATASET_DETAIL_GET_TARGET_LABELS_SUCCESS,
  DATASET_DETAIL_AUTO_LABELS_REQUEST,
  DATASET_DETAIL_AUTO_LABELS_SUCCESS,
  DATASET_DETAIL_AUTO_LABELS_FAILURE,
  DATASET_DETAIL_HANDLE_RESET_PAGE_ADVANCED_FILTER,
  DATASET_DETAIL_CHANGE_FILTER,
  DATASET_DETAIL_CLEAR_WHEN_LEAVE,
  DATASET_DETAIL_SET_IS_ADVANCED_SEARCH,
} from "redux/actions";

export const getListDatasetDetail = (payload) => ({
  type: GET_LIST_DATASET_DETAIL,
  payload,
});

export const getListDatasetDetailSuccess = ({
  datasetDetails,
  datasetName,
  dataset_id,
  currentPage,
  pageSize,
  totalPage,
  totalItem,
  queries,
}) => ({
  type: GET_LIST_DATASET_DETAIL_SUCCESS,
  payload: {
    datasetDetails,
    datasetName,
    dataset_id,
    currentPage,
    pageSize,
    totalPage,
    totalItem,
    queries,
  },
});

export const changeLimitDatasetDetail = (payload) => ({
  type: DATASET_DETAIL_CHANGE_LIMIT,
  payload,
});

export const changePageDatasetDetail = (payload) => ({
  type: DATASET_DETAIL_CHANGE_PAGE,
  payload,
});

export const handleToggleOne = (payload) => ({
  type: DATASET_DETAIL_TOGGLE_ONE,
  payload,
});

export const handleSelectAll = (payload) => ({
  type: DATASET_DETAIL_TOGGLE_ALL,
  payload,
});

export const handleDeSelectAll = (payload) => ({
  type: DATASET_DETAIL_DESELECT_ALL,
  payload,
});

export const fetchModuleCodeRequest = (payload) => ({
  type: FETCH_MODULE_CODE_REQUEST,
  payload,
});

export const fetchModuleCodeSuccess = (payload) => ({
  type: FETCH_MODULE_CODE_SUCCESS,
  payload,
});

export const changeFilterCondition = (payload) => ({
  type: DATASET_DETAIL_CHANGE_FILTER_CONDITION,
  payload,
});

export const openSmartTagDrawer = () => ({
  type: DATASET_DETAIL_OPEN_SMART_TAG_DRAWER,
});

export const closeSmartTagDrawer = () => ({
  type: DATASET_DETAIL_CLOSE_SMART_TAG_DRAWER,
});

export const handleSelectSourceId = (payload) => ({
  type: DATASET_DETAIL_SELECT_SOURCE_ID,
  payload,
});

export const updateItemsByTags = (payload) => ({
  type: DATASET_UPDATE_ITEMS,
  payload,
});

export const openAdvancedSearchDrawer = () => ({
  type: DATASET_DETAIL_OPEN_ADVANCED_SEARCH_DRAWER,
});

export const closeAdvancedSearchDrawer = () => ({
  type: DATASET_DETAIL_CLOSE_ADVANCED_SEARCH_DRAWER,
});

export const changeAdvancedFilterCondition = (payload) => ({
  type: DATASET_DETAIL_CHANGE_ADVANCED_FILTER,
  payload,
});

export const changeAdvancedFilterConditionByDropdown = (payload) => ({
  type: DATASET_DETAIL_CHANGE_ADVANCED_FILTER_CONDITION,
  payload,
});

export const changeAdvancedFilter = (payload) => ({
  type: DATASET_DETAIL_CHANGE_ADVANCED_FILTER,
  payload,
});

export const setCurrentDatasetId = (payload) => ({
  type: DATASET_DETAIL_SET_CURRENT_DATASET_ID,
  payload,
});

export const getDataByAdvancedSearch = (payload) => ({
  type: DATASET_DETAIL_GET_DATA_BY_ADVANCED,
  payload,
});

export const getDataByAdvancedSearchSuccess = (payload) => ({
  type: DATASET_DETAIL_GET_DATA_BY_ADVANCED_SUCCESS,
  payload,
});

export const clearAdvancedFilter = (payload) => ({
  type: DATASET_DETAIL_CLEAR_ADVANCED_FILTER_CONDITION,
  payload,
});

export const updateStatusImage = (payload) => ({
  type: DATASET_DETAIL_UPDATE_STATUS_IMAGE,
  payload,
});

export const bulkUpdateStatusRequest = (payload) => ({
  type: DATASET_DETAIL_BULK_UPDATE_STATUS_REQUEST,
  payload,
});

export const bulkUpdateStatusSuccess = () => ({
  type: DATASET_DETAIL_BULK_UPDATE_STATUS_SUCCESS,
});

export const bulkUpdateStatusFailure = () => ({
  type: DATASET_DETAIL_BULK_UPDATE_STATUS_FAILURE,
});

export const updateItemByStatusSuccess = (payload) => ({
  type: DATASET_DETAIL_UPDATE_ITEM_BY_STATUS_SUCCESS,
  payload,
});

export const onChangeViewType = (payload) => ({
  type: DATASET_DETAIL_CHANGE_VIEW_TYPE,
  payload,
});

export const toggleImportDataDrawer = () => ({
  type: DATASET_DETAIL_TOGGLE_IMPORT_DATA,
});

export const toggleExportDataDrawer = () => ({
  type: DATASET_DETAIL_TOGGLE_EXPORT_DATA,
});

export const toggleAssignMemberDrawer = () => ({
  type: DATASET_DETAIL_TOGGLE_ASSIGN_MEMBER,
});

export const assignMemberSuccess = (payload) => ({
  type: DATASET_DETAIL_ASSIGN_MEMBER_SUCCESS,
  payload,
});

export const uncheckIds = () => ({
  type: DATASET_DETAIL_UNCHECK_IDS,
});

export const toggleUnassignModal = () => ({
  type: DATASET_DETAIL_TOGGLE_UNASSIGN_MODAL,
});

export const unAssignMemberSuccess = (payload) => ({
  type: DATASET_DETAIL_UNASSIGN_MEMBER_SUCCESS,
  payload,
});

export const toggleDeleteModal = () => ({
  type: DATASET_DETAIL_TOGGLE_DELETE_MODAL,
});

export const onDeleteImages = (payload) => ({
  type: DATASET_DETAIL_DELETE_IMAGES,
  payload,
});

export const clearDatasetIdsAdvanced = () => ({
  type: DATASET_DETAIL_CLEAR_DATASET_IDS,
});

export const clearAdvancedSearchConditions = (payload) => ({
  type: CLEAR_ADVANCED_SEARCH_PAGE_CONDITION,
  payload,
});

export const onChangeCountPerRow = (payload) => ({
  type: DATASET_DETAIL_CHANGE_COUNTS_PER_ROW,
  payload,
});

export const getAllDatasetsInProjects = (payload) => ({
  type: DATASET_DETAIL_GET_ALL_DATASETS_OF_PROJECT,
  payload,
});

export const getAllDatasetsInProjectsSuccess = (payload) => ({
  type: DATASET_DETAIL_GET_ALL_DATASETS_OF_PROJECT_SUCCESS,
  payload,
});

export const getPermissionsByRole = (payload) => ({
  type: DATASET_DETAIL_GET_MATTRIX_PERMISSION,
  payload,
});

export const getPermissionsByRoleSuccess = (payload) => ({
  type: DATASET_DETAIL_GET_MATTRIX_PERMISSION_SUCCESS,
  payload,
});

export const onToggleAutoLabelDialog = () => ({
  type: DATASET_DETAIL_TOGGLE_AUTO_LABEL_DIALOG,
});

export const getTargetLabelsRequest = (payload) => ({
  type: DATASET_DETAIL_GET_TARGET_LABELS,
  payload,
});

export const getTargetLabelsSuccess = (payload) => ({
  type: DATASET_DETAIL_GET_TARGET_LABELS_SUCCESS,
  payload,
});

export const autoLabelsRequest = (payload) => ({
  type: DATASET_DETAIL_AUTO_LABELS_REQUEST,
  payload,
});

export const autoLabelsSuccess = () => ({
  type: DATASET_DETAIL_AUTO_LABELS_SUCCESS,
});

export const autoLabelFailure = () => ({
  type: DATASET_DETAIL_AUTO_LABELS_FAILURE,
});

export const onResetPageAdvancedFilter = () => ({
  type: DATASET_DETAIL_HANDLE_RESET_PAGE_ADVANCED_FILTER,
});

export const changeFilter = (payload) => ({
  type: DATASET_DETAIL_CHANGE_FILTER,
  payload,
});

export const clearWhenLeave = () => ({ type: DATASET_DETAIL_CLEAR_WHEN_LEAVE });

export const setIsAdvancedSearch = () => ({
  type: DATASET_DETAIL_SET_IS_ADVANCED_SEARCH,
});
